module.exports = __webpack_public_path__ + "img/invoice.532690e6.svg";